module.exports = __webpack_public_path__ + "img/18.307fa326.png";